import { create } from "zustand";

const useNewDetectedObjectStore = create((set, get) => ({
  type: "poles",
  setType: (value) => set(() => ({ type: value })),

  newPointPreviewMap: false,
  setNewPointPreviewMap: (value) => set(() => ({ newPointPreviewMap: value })),

  previewImagesVisible: false,
  setPreviewImagesVisible: (value) => set(() => ({ previewImagesVisible: value })),

  previewImagesNewPoint: [],
  setPreviewImagesNewPoint: (images) =>
    set(() => ({ previewImagesNewPoint: images })),

  newPointPosition: [],
  setNewPointPosition: (position) =>
    set(() => ({ newPointPosition: position })),

  annotationType: () => {
    const type = get().type;
    return type.endsWith('s') ? type.slice(0, -1) : type;
  }
}));

export default useNewDetectedObjectStore;
